/**
 * AgencyApply — DEPRECATED (design/013)
 *
 * Self-service agency sign-up has been removed.
 * Agency accounts are now provisioned by VuSub staff only.
 * This route is kept so old bookmarks don't 404, but only shows a
 * "contact us" message.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideUp = keyframes`from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); }`;

const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(160deg, #08080f 0%, #0d0d1c 60%, #111128 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  animation: ${fadeIn} 250ms ease;
`;

const Card = styled.div`
  background: linear-gradient(160deg, #111120 0%, #16162a 100%);
  border: 1px solid rgba(255,255,255,0.09);
  border-radius: 22px;
  padding: 48px 40px 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 32px 80px rgba(0,0,0,0.6);
  animation: ${slideUp} 250ms ease;
  text-align: center;
`;

const Logo = styled.div`
  font-size: 1rem;
  font-weight: 800;
  color: #ff4757;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 32px;
`;

const Icon = styled.div`
  font-size: 2.8rem;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  color: white;
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0 0 12px;
`;

const Body = styled.p`
  color: rgba(255,255,255,0.45);
  font-size: 0.88rem;
  line-height: 1.6;
  margin: 0 0 32px;

  a {
    color: #ff4757;
    text-decoration: none;
    font-weight: 600;
    &:hover { text-decoration: underline; }
  }
`;

const BackBtn = styled.button`
  background: transparent;
  color: rgba(255,255,255,0.5);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 10px;
  font-size: 0.88rem;
  padding: 11px 20px;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;

  &:hover {
    border-color: rgba(255,255,255,0.35);
    color: white;
  }
`;

const AgencyApply = () => {
  const navigate = useNavigate();

  return (
    <Page>
      <Card>
        <Logo>vusub.ai</Logo>
        <Icon>📣</Icon>
        <Title>Become an Agency Partner</Title>
        <Body>
          Agency accounts are provisioned by invitation only.
          To get started as an agency partner, email{' '}
          <a href="mailto:hello@vusub.ai">hello@vusub.ai</a> and we'll
          get you set up.
        </Body>
        <BackBtn onClick={() => navigate('/')}>← Back to app</BackBtn>
      </Card>
    </Page>
  );
};

export default AgencyApply;
